import { ErrorMessage, SuccessMessage } from "#root/components/alert";
import { CorrespondencePreview } from "#root/components/correspondence";
import { disappear } from "#root/components/disappear";
import { GlyphLoading } from "#root/components/glyphs";
import { correspondenceCollection } from "#root/schema/correspondence";
import { useData } from "#root/utility/hooks";
import type { ReactNode } from "react";
import { useCallback, useState } from "react";
import PageLayout from "./layout";

function doNothing(evnt) {
  evnt.preventDefault();
  evnt.stopPropagation();
}

export default function AdminCorrespondenceDetails({ correspondenceId: id }): ReactNode {
  const [details, setDetails] = useData(async () => {
    if (id) {
      const { row } = await correspondenceCollection.details(id);
      return row;
    }
  }, [id]);

  const [message, setMessage] = useState<ReactNode | null>(null);

  const sendEmail = useCallback(async () => {
    try {
      const { row } = await correspondenceCollection.action(`${id}/send`);
      setDetails(row);
      setMessage(disappear(<SuccessMessage>Email has been sent</SuccessMessage>));
    } catch (error) {
      setMessage(disappear(<ErrorMessage error/>));
    }
  }, [setDetails, id]);

  if (!details) {
    return <GlyphLoading/>;
  }

  return (
    <PageLayout title="Correspondence Details">
      <section>
        <div className="button-row">
          {details.status === "SENT" ? (
            <a className="button disabled" onClick={doNothing}>
              Correspondence Has Been Sent
            </a>
          ) : (
            <a className="button" onClick={sendEmail}>
              Send Email
            </a>
          )}
        </div>
        {message}
        <CorrespondencePreview preview={details}/>
      </section>
    </PageLayout>
  );
}
